import { fromJS } from 'immutable';
export var SET_SESSION = 'session/SET';
export var CLEAR_SESSION = 'session/CLEAR';
export function setSession(session) {
  return {
    type: SET_SESSION,
    session: session
  };
}
export function clearSession(session) {
  return {
    type: CLEAR_SESSION,
    session: session
  };
} // Reducer

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      _ref$session = _ref.session,
      session = _ref$session === void 0 ? null : _ref$session;

  switch (type) {
    case 'SET_SESSION':
      return fromJS(session);

    case 'CLEAR_SESSION':
      return null;

    default:
      return state;
  }
});